import type { JSX } from 'react'
import type { IPopupComponentProps } from 'blocks/Popup'

import { PopupComponent } from 'blocks/Popup'
import { COLOR } from 'vars/color'
import { ProfilesPopupWrapper } from '../PopupComponent.styled'

export const ProfilesRemovePopup = ({
  children,
  withCloseButton = false,
  withGradientScrollableBlock = true,
  overlayColor = COLOR.SURFACE_OPACITY_DARK_70,
  ...rest
}: IPopupComponentProps): JSX.Element => {
  return (
    <ProfilesPopupWrapper>
      <PopupComponent
        withCloseButton={withCloseButton}
        withGradientScrollableBlock={withGradientScrollableBlock}
        overlayColor={overlayColor}
        {...rest}
      >
        {children}
      </PopupComponent>
    </ProfilesPopupWrapper>
  )
}
